import { useState, useEffect } from "react";
import { delayRender, continueRender } from "remotion";
import { getVideoMetadata } from "@remotion/media-utils";

const DEFAULT_ASPECT = 16 / 9;

/**
 * Detects the source video's aspect ratio (width / height).
 * Uses delayRender/continueRender so Remotion SSR waits for the result
 * before rendering any frames. Falls back to 16:9 on error.
 */
export function useSourceAspectRatio(videoUrl: string): number {
  const [aspectRatio, setAspectRatio] = useState(DEFAULT_ASPECT);
  const [handle] = useState(() => delayRender("Detecting source video aspect ratio"));

  useEffect(() => {
    getVideoMetadata(videoUrl)
      .then((metadata) => {
        setAspectRatio(metadata.width / metadata.height);
        continueRender(handle);
      })
      .catch(() => {
        continueRender(handle);
      });
  }, [videoUrl, handle]);

  return aspectRatio;
}
